import React from 'react';

import { colors } from 'constants-colors';
import { getTextColor } from 'lane-shared/helpers';

import { MjmlText } from '../MjmlComponentsV2';

type Props = {
  children: React.ReactNode;
  backgroundColor?: string;
  lineHeight?: number;
  fontSize?: number;
  align?: 'center' | 'left' | 'right' | undefined;
  fontWeight?: string;
  paddingBottom?: number;
  paddingTop?: number;
  color?: string;
  fontFamily?: string;
};

/**
 * @deprecated This component has been moved to @emails library (libs/emails/src/lib/components/legacy/EmailText.tsx).
 * Please import from 'emails' package instead.
 */
export default function EmailText({
  children,
  backgroundColor,
  lineHeight = 20,
  fontSize = 13,
  color,
  fontFamily = "'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif",
  ...props
}: Props) {
  const textColor = backgroundColor
    ? getTextColor(backgroundColor)
    : colors.darkCharcoal;

  return (
    <MjmlText
      fontFamily={fontFamily}
      fontSize={fontSize}
      lineHeight={lineHeight}
      color={color || textColor}
      {...props}
    >
      {children}
    </MjmlText>
  );
}
